import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {fetchEntities} from "../../actions/entities";
import {allEntitySelector} from "../../reducers/entity";
import {endpointFindAll, propDisplay, propId} from "../../utils/metaUtil";

class RefDropdown extends React.Component {
    componentDidMount = () => this.onInit(this.props);
    onInit = props => {
        const {entityType} = props;
        props.fetchEntities(
            entityType,
            endpointFindAll(props.meta, entityType)
        );
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.entityType !== this.props.entityType) {
            this.onInit(nextProps);
        }
    }
    renderItems = (meta, entityType, entities) => {
       return Object.values(entities).map(e =>
            <option key={e[propId(meta, entityType)]} value={e[propId(meta, entityType)]}>{e[propDisplay(meta, entityType)]}</option>
        );
    };

    renderUnselected = (addUnselected) => {
        if (addUnselected) {
            return <option key="NULL" value="NULL">Select an Option</option>
        }
    };

    render() {
        const {meta, name, value, disabled, addUnselected, entityType, entities, onChange} = this.props;
        return (
            <div>
                <select className="form-control" name={name} defaultValue={addUnselected ? "NULL" : value} onChange={onChange} disabled={disabled}>
                    {this.renderUnselected(addUnselected)}
                    {this.renderItems(meta, entityType, entities)};
                </select>

            </div>
        );
    }
}

RefDropdown.propTypes = {
    meta: PropTypes.shape().isRequired,
    name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    entities:  PropTypes.arrayOf(PropTypes.shape()).isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    addUnselected: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};
RefDropdown.defaultProps = {
    addUnselected: false,
    disabled:false
};

function mapStateToProps(state, props) {
    return {
        entities: allEntitySelector(state, props.entityType),
    };
}

export default connect(mapStateToProps, {fetchEntities})(RefDropdown);



// WEBPACK FOOTER //
// ./src/components/widgets/RefDropdown.js